export default __webpack_public_path__ + "static/media/icon-clock.a624953b.svg";